import { BaseApiService } from '@/app/services/base/ApiService';
//import { AuthMockHandler } from '@/mocks/handlers/AuthMockHandler';
import { getEnvConfig } from '@/app/utils/env';
import { SessionValidationResponse } from '@/shared/types/auth';

class AuthServices extends BaseApiService {
  constructor() {
    const envConfig = getEnvConfig();
    
    const config = {
      baseURL: envConfig.API_SPHINX_SERVICE_BASE_URL,
      timeout: envConfig.API_TIMEOUT,
      requiresAuth: false, // Authentication service itself does not require auth headers
      //mockHandler: new AuthMockHandler(envConfig.MOCK_API_DELAY),
    };
    super(config);
  }

  /**
   * Validate session identifier with the backend
   * @param sessionIdentifier - The session identifier from the decoded JWT
   * @returns Promise<SessionValidationResponse>
   */
  async validateSession(sessionIdentifier: string): Promise<SessionValidationResponse> {
    const response = await this.post<SessionValidationResponse>(`/session/validate?sid=${sessionIdentifier}`, {
      sessionIdentifier,
    });
    return response.result;
  }

  /**
   * Invalidate session identifier with the backend
   * @param sessionIdentifier - The session ID to invalidate
   * 
   */
  async invalidateSession(sessionIdentifier: string): Promise<void> {
    const response = await this.post<void>(`/session/invalidate`, sessionIdentifier, {
      headers: { 'X-RCCL-Session-ID': sessionIdentifier },
    });
    return response.result;
  }
}

// Create and export singleton instance
const authService = new AuthServices();
export default authService;